<template>
  <div>
    <div class="relative flex justify-center">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/casp-plus/02714035011600143876743/graphic.png"
        alt="Logo"
        draggable="false"
        width="70%"
        height="100%"
      />

      <v-select
        placeholder="Select action item"
        :options="options"
        v-model="resourceServer.value"
        style="width: 20%; top: 15.25%; right: 29.9%; position: absolute"
        :class="{
          correct: resourceServer.correct,
          invalid: resourceServer.correct === false,
        }"
      />

      <v-select
        placeholder="Select action item"
        :options="options"
        v-model="b2bClientApplication.value"
        style="width: 20%; bottom: 24.25%; right: 29.9%; position: absolute"
        :class="{
          correct: b2bClientApplication.correct,
          invalid: b2bClientApplication.correct === false,
        }"
      />

      <v-select
        placeholder="Select action item"
        :options="options"
        v-model="authorizationServer.value"
        style="width: 20%; bottom: 56.5%; left: 26.4%; position: absolute; background-color: #02050d"
        :class="{
          correct: authorizationServer.correct,
          invalid: authorizationServer.correct === false,
        }"
      />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      options: ['Access issued tokens', 'Grant access', 'Authorize access to other applications'],

      authorizationServer: {
        answer: 'Grant access',
        value: null,
        correct: null,
      },

      resourceServer: {
        answer: 'Access issued tokens',
        value: null,
        correct: null,
      },

      b2bClientApplication: {
        answer: 'Authorize access to other applications',
        value: null,
        correct: null,
      },
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.authorizationServer.correct = this.authorizationServer.value === this.authorizationServer.answer;
      this.resourceServer.correct = this.resourceServer.value === this.resourceServer.answer;
      this.b2bClientApplication.correct = this.b2bClientApplication.value === this.b2bClientApplication.answer;

      totalScore += this.authorizationServer.correct ? 1 : 0;
      totalScore += this.resourceServer.correct ? 1 : 0;
      totalScore += this.b2bClientApplication.correct ? 1 : 0;

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
